import { render } from "./LegalAdvice.vue?vue&type=template&id=5ef9e6ff"
import script from "./LegalAdvice.vue?vue&type=script&lang=js"
export * from "./LegalAdvice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__